module.exports = __webpack_public_path__ + "static/media/sample_template_flipbook_bg.03dfada7.png";